export const compareHero = () => {
  const radioButtons = document.querySelectorAll('.compare-options input[name="compare_option"]');
  
  const compareHeroImg = document.querySelector('.compare_option_image');
  const compareHeroCtaWrappers = document.querySelectorAll('.compare_option_cta');
  
  radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('change', function () {
      const selectedOptionId = this.id;

      // Change the hero image source
      const optionImgSrc = document
        .querySelector(`input[id="${selectedOptionId}"]`)
        .getAttribute('data-option-img-src');
      compareHeroImg.setAttribute('srcset', optionImgSrc);
      compareHeroImg.setAttribute('src', optionImgSrc);

      // Change the hero CTA link
      compareHeroCtaWrappers.forEach((ctaWrapper) => {
        if (ctaWrapper.getAttribute('id') === `${selectedOptionId}_cta`) {
          ctaWrapper.classList.toggle('hidden');
        } else {
          if (!ctaWrapper.classList.contains('hidden')) {
            ctaWrapper.classList.toggle('hidden');
          }
        }
      });

    });
  });
}
